module.exports = __webpack_public_path__ + "img/drinks-food.03f52968.svg";